<template>
  <div class="device" v-if="device">

    <div class="device-header">
      <div class="device-header_name" v-if="device.title">{{ device.title }}</div>
    </div>

    <div class="">
      <el-table
          v-if="device.diagnostic_field && !conclusion"
          stripe
          :data="device.diagnostic_field"
          style="width: calc(100% - 10px)"
          class="device-table"
          :default-expand-all="true"
          header-cell-class-name="device-table-header"
          width="100%"
      >
        <el-table-column prop="title" label="Показатель"></el-table-column>
        <el-table-column prop="description" label="Ед. изм"></el-table-column>
        <el-table-column type="expand" class-name="hidden" :width="0">
          <template slot-scope="scope">

            <files-viewer
                @openHeadMap="openHeadMap"
                @openFile="openFile"
                :files="scope.row.value"
            ></files-viewer>

          </template>
        </el-table-column>

        <el-table-column label="Значение" align="right" width="150">
          <template slot-scope="scope">

            <div v-if="scope.row.value" class="device-info">
              <el-tooltip
                  effect="dark"
                  v-if="scope.row.value.norm"
                  :content="scope.row.value.norm.long_description"
                  placement="top-start">
                <el-tag v-if="scope.row.value.input" class="black-el-tag" :color="scope.row.value.norm.color"
                        type="info">
                  {{ scope.row.value.input }}
                </el-tag>
                <div v-else class="device-field__empty">Поле не заполнено</div>
              </el-tooltip>
              <div class="device-info__value" v-else>
                <span> {{ scope.row.value.input }}</span>
              </div>
              <div v-if="scope.row.value.file">
              </div>
            </div>
            <div v-else>
              <div class="device-field__empty">Поле не заполнено</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <template v-if="false">
      <div class="bad-count" v-if="!conclusion">
        <el-radio @change="sendComment" v-model="badCountType" :label="0">все показатели в норме</el-radio>
        <el-radio @change="sendComment" v-model="badCountType" :label="1" class="el-radio-red">
          <el-input-number
              v-model="badCountIn"
              controls-position="right"
              @change="handleChange"
              :controls="false"
              :min="1"
              :max="50"
              class="input-number"
          ></el-input-number>
          <span class="bad-count__title">{{ badCountIn |  badCountTitle }} не в норме</span>
        </el-radio>
      </div>
    </template>

    <div class="comment" >
      <template v-if="!conclusion">
        <template v-if="photos && device.deviation_field">
          <div v-if="getComment.auto_comment" class="comment__box">
            <div class="comment__title">Автоматический комментарий</div>
            <div class="comment__text">{{ getComment.auto_comment }}</div>
          </div>
          <el-button v-if="!loadingThermogram"
                     :loading="loadingBtn"
                     type="primary" @click="openHeadMap">Анализ</el-button>
          <el-button v-else type="primary" :loading="true">Загрузка dtv файлов</el-button>
        </template>

        <div class="comment__title" style="margin-top: 12px;">Добавьте ваш комментарий</div>
        <el-input
            v-model="counter"
            v-loading="loading"
            @change="conclusion ? sendConсlusion($event) : sendComment($event)"
            show-word-limit
            type="textarea"
            maxlength="1300"
            autosize
            placeholder="Введите комментарий..."
            class="comment__input"
        />

      </template>

      <div class="comment__box" v-if="conclusion">
        <el-input
            type="textarea"
            maxlength="300"
            autosize
            placeholder="Введите комментарий...."
            :disabled="!conclusionEdit"
            class="comment__input"
            @change="conclusion ? sendConсlusion($event) : sendComment($event)"
            v-model="counter"
            v-loading="loading"
        />

      </div>

    </div>
  </div>
</template>

<script>
import FilesViewer from "@/components/visit/FilesViewer";

export default {
  name: "Device",
  components: {FilesViewer},
  props: {
    loadingThermogram: {},
    device: {},
    comment: {
      required: false,
      default: function () {
        return []
      }
    },
    badCount: Number,
    visitId: {},
    user: {},
    conclusion: Boolean,
    conclusionComment: {
      required: false
    },
    conclusionEdit: {         }
  },
  data: function () {
    return {
      loading: false,
      loadingBtn: false,
      isOpenModalViewImage: false,
      counter: 'this.getComment',
      badCountType: 0,
      badCountIn: 1,
    };
  },
  filters: {
    badCountTitle(value) {
      let arr = ["показатель", "показателя", "показателей"];
      return (arr[
          value % 100 > 4 && value % 100 < 20
              ? 2
              : [2, 0, 1, 1, 1, 2][value % 10 < 5 ? value % 10 : 5]
          ])
    }
  },
  computed: {
    allDiagnosticFields() {
      let allElements = []
      this.device.diagnostic_field.forEach((element) => {
        allElements.push(element.id)
      })
      return allElements
    },
    photos() {

      let isPhoto = false
      if (!this.device.diagnostic_field) return

      this.device.diagnostic_field.forEach((field) => {
        if (!field.value) return

        field.value.file.forEach(() => {
          isPhoto = true
        })
      })
      return isPhoto
    },
    getComment() {
      if (!this.comment) return

      let index = this.comment.findIndex(
          (e) => e.device_id == this.device.id
      )

      return index >= 0 ? this.comment[index] : {}
    }

  },
  watch: {
    getComment() {
      // value
      // this.counter = this.conclusion ? this.conclusionComment : value.comment
      this.initCounters()
    },
    conclusionComment() {
      this.initCounters()
    },
  },
  mounted() {
    this.initCounters()
  },

  methods: {
    initCounters() {
      this.counter = this.conclusion ? this.conclusionComment : this.getComment.comment

      this.badCountType = this.getComment.bad_count ? 1 : 0
      this.badCountIn = this.getComment.bad_count ? this.getComment.bad_count : 1
    },
    handleChange() {
      this.badCountType = 1;
      this.sendComment()
    },
    openFile(file) {
      this.$emit("openFile", file);
    },
    openHeadMap() {
      this.loadingBtn = true

      setTimeout(() => {

        let diagnosticData = {
          // image,
          deviationField: this.device.deviation_field,
          comment: this.comment.comment,
          deviceId: this.device.id,
          markup_diagnosis_type: this.device.markup_diagnosis_type,
          allDiagnosticFields: this.allDiagnosticFields
        }

        this.$emit("openHeadMap", diagnosticData);
        this.loadingBtn = false

      }, 100)
    },

    sendConсlusion() {

      this.loading = true

      this.$api.visit
          .saveVisitLightComment(this.visitId, {comment: this.counter})
          .then(() => {
            this.$notify.success({
              title: "Удачно",
              message: "Комментарий был сохранен",
            })
          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка сохранения 😕",
              message: res.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    sendComment() {
      let data = {
        comment: this.counter ? this.counter : null,
        bad_count: (this.badCountType) ? this.badCountIn : 0
      };

      this.loading = true
      this.$api.visit
          .saveComment(this.visitId, this.device.id, data)
          .then(() => {
            this.$notify.success({
              title: "Успешно",
              message: "Данные обновлены",
            });
          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = !!0
          })
    },
    showAll() {
      this.isOpenModalViewImage = true
    }
  },
};
</script>

<style scoped lang="scss">
.device-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_name {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
    padding: 6px;

    color: #111111;
  }

  &_action {

  }
}

.device {
  background: #fff;
  border-radius: 6px;
  padding: 10px;
  margin-bottom: 10px;


  .file_name {
    cursor: pointer;
    color: #111;

    &:hover {
      color: #32e6be;
    }
  }

  .device-btn {
    margin-top: 10px;
  }
}


.input-number {
  width: 50px;
  padding-right: 10px;
}

.device-field {
  &__name {
    color: #545659;
    font-size: 16px !important;
    line-height: 26px;
    margin-top: 15px;

    display: inline-block;
  }

  &__description {
    color: #939393;
    font-size: 14px !important;
    line-height: 26px;
    margin: 10px 0 0 10px;

    display: inline-block;
  }

  &__empty {
    color: #ccc;
    font-size: 12px;
    line-height: 13px;
  }
}

.bad-count {
  margin-top: 20px;
  padding: 0 5px;

  &__title {

  }
}

.black-el-tag {
  /deep/ {
    color: #111;
    font-weight: 500;
    font-size: 12px;

    height: auto;
    white-space: break-spaces;

  }
}

.el-radio-red {

  /deep/ .el-radio__input.is-checked .el-radio__inner {
    border-color: #FF6464;
    background: #FF6464;
  }

  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #FF6464;

  }
}

.comment {
  margin-top: 5px;
  padding: 0 6px;

  &__box {
    margin: 10px 0;
  }

  &__title {
    margin: 8px 0;

    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #111111;
  }

  &__text {
    border-radius: 3px;

    word-wrap: break-word;
    word-break: break-word !important;
    font-size: 12px;
    line-height: 13px;
    color: #4f4f4f;
  }

  &__input {
    font-family: SF Pro Display !important;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 13px;
  }
}


/deep/ .device-table {
  margin-top: 16px;


  &:before {
    content: "";
    position: absolute;
    background: none;
    z-index: 1;
  }

  .el-table__row--striped {
    border-radius: 4px;

    td {
      background: #EFEFF4 !important;

    }
  }

  .device-table-header {
    display: none;

    .cell {
      padding: 0 6px;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 13px;

      color: #111;
    }
  }

  th.is-leaf, td {
    border: 0;
  }

  .cell {
    padding: 0 6px;
  }
}

/deep/ .hidden {
  width: 0 !important;
  max-width: 0;
  overflow: hidden;
  padding: 0;

  .cell {
    display: none;
  }
}


</style>
